import api from "./Api";

class AuthService {
  async login(data: { username: string; password: string }) {
    try {
      const response = await api.post(`auth/login`, data);
      return [response?.data?.data, undefined];
    } catch (e: any) {
      return [
        undefined,
        "Os dados informados não conferem, por favor verique os dados e tente novamente.",
      ];
    }
  }

  async authorizationSSO(data:any) {
    try {
      const response = await api.post(`auth/sso/callback`, data);
      return [response?.data?.data, undefined];
    } catch (e: any) {
      return [
        undefined,
        "Os dados informados não conferem, por favor verique os dados e tente novamente.",
      ];
    }
  }


  async logout() {
    try {
      const response = await api.get(`auth/logout`);
      return [response?.data, undefined];
    } catch (e: any) {
      return [
        undefined,
        e?.error ||
          "Os dados informados não conferem, por favor verique os dados e tente novamente.",
      ];
    }
  }

  async forgot(data: any) {
    try {
      const response = await api.post(`auth/forgot`, data);
      return [response?.data?.data, undefined];
    } catch (e: any) {
      return [
        undefined,
        "Os dados informados não conferem, por favor verique os dados e tente novamente.",
      ];
    }
  }

  async reset(data: any) {
    try {
      const response = await api.post(`auth/reset-password`, data);
      return [response?.data?.data, undefined];
    } catch (e: any) {
      return [
        undefined,
        "Os dados informados não conferem, por favor verique os dados e tente novamente.",
      ];
    }
  }
}

export default AuthService;
